import React from 'react'

import Aux from 'hoc/ReactAux/ReactAux'

const DeliveryTrackingItem = (props) => {

    let layout = null
    switch(props.order.statusOrderDelivery){
      case 'NOT_MADE':
        layout =
        <Aux>
          <span>Order {props.order.idOrder} &#8226; {props.order.dateRegOrderFormatted}</span>
          <div className="steps">
            <div className="step one">
              <div className="s1-on"></div>
                <div className="step-info">
                  <h4>STEP ONE</h4>
                  <h3>Awaiting Preparation</h3>
                </div>
            </div>
              <div className="step two">
                <div className="s2-off"></div>
                  <div className="step-info">
                    <h4>STEP TWO</h4>
                    <h3>Awaiting Pickup</h3>
                  </div>
              </div>
              <div className="step three">
                <div className="s3-off"></div>
                  <div className="step-info">
                    <h4>STEP THREE</h4>
                    <h3>On The Way</h3>
                  </div>
              </div>
              <div className="step four">
                <div className="s4-off"></div>
                  <div className="step-info">
                    <h4>STEP FOUR</h4>
                    <h3>Delivered</h3>
                  </div>
              </div>
          </div>
          <span className="arrival-time">Estimated Arrival Time {props.order.deliveryDateFormatted}</span>
        </Aux>
        break
      case 'WAITING':
        layout =
        <Aux>
          <span>Order {props.order.idOrder} &#8226; {props.order.dateRegOrderFormatted}</span>
          <div className="steps">
            <div className="step one">
              <div className="s1-off"></div>
                <div className="step-info">
                  <h4>STEP ONE</h4>
                  <h3>Awaiting Preparation</h3>
                </div>
            </div>
              <div className="step two">
                <div className="s2-on"></div>
                  <div className="step-info">
                    <h4>STEP TWO</h4>
                    <h3>Awaiting Pickup</h3>
                  </div>
              </div>
              <div className="step three">
                <div className="s3-off"></div>
                  <div className="step-info">
                    <h4>STEP THREE</h4>
                    <h3>On The Way</h3>
                  </div>
              </div>
              <div className="step four">
                <div className="s4-off"></div>
                  <div className="step-info">
                    <h4>STEP FOUR</h4>
                    <h3>Delivered</h3>
                  </div>
              </div>
          </div>
          <span className="arrival-time">Estimated Arrival Time {props.order.deliveryDateFormatted}</span>
        </Aux>
        break
      case 'IN_TRANSIT':
        layout =
        <Aux>
          <span>Order {props.order.idOrder} &#8226; {props.order.dateRegOrderFormatted}</span>
          <div className="steps">
            <div className="step one">
              <div className="s1-off"></div>
                <div className="step-info">
                  <h4>STEP ONE</h4>
                  <h3>Awaiting Preparation</h3>
                </div>
            </div>
              <div className="step two">
                <div className="s2-off"></div>
                  <div className="step-info">
                    <h4>STEP TWO</h4>
                    <h3>Awaiting Pickup</h3>
                  </div>
              </div>
              <div className="step three">
                <div className="s3-on"></div>
                  <div className="step-info">
                    <h4>STEP THREE</h4>
                    <h3>On The Way</h3>
                  </div>
              </div>
              <div className="step four">
                <div className="s4-off"></div>
                  <div className="step-info">
                    <h4>STEP FOUR</h4>
                    <h3>Delivered</h3>
                  </div>
              </div>
          </div>
          <span className="arrival-time">Estimated Arrival Time {props.order.deliveryDateFormatted}</span>
        </Aux>
        break
      case 'DONE':
        layout =
        <Aux>
          <span>Order {props.order.idOrder} &#8226; {props.order.dateRegOrderFormatted}</span>
          <div className="steps">
            <div className="step one">
              <div className="s1-off"></div>
                <div className="step-info">
                  <h4>STEP ONE</h4>
                  <h3>Awaiting Preparation</h3>
                </div>
            </div>
              <div className="step two">
                <div className="s2-off"></div>
                  <div className="step-info">
                    <h4>STEP TWO</h4>
                    <h3>Awaiting Pickup</h3>
                  </div>
              </div>
              <div className="step three">
                <div className="s3-off"></div>
                  <div className="step-info">
                    <h4>STEP THREE</h4>
                    <h3>On The Way</h3>
                  </div>
              </div>
              <div className="step four">
                <div className="s4-on"></div>
                  <div className="step-info">
                    <h4>STEP FOUR</h4>
                    <h3>Delivered</h3>
                  </div>
              </div>
          </div>
          <span className="arrival-time">Estimated Arrival Time {props.order.deliveryDateFormatted}</span>
        </Aux>
        break
      case 'DBO':
        layout =
        <Aux>
          <span>Order {props.order.idOrder} &#8226; {props.order.dateRegOrderFormatted}</span>
          <div className="steps">
            <div className="step one">
              <div className="s1-off"></div>
                <div className="step-info">
                  <h4>STEP ONE</h4>
                  <h3>Awaiting Preparation</h3>
                </div>
            </div>
              <div className="step two">
                <div className="s2-off"></div>
                  <div className="step-info">
                    <h4>STEP TWO</h4>
                    <h3>Awaiting Pickup</h3>
                  </div>
              </div>
              <div className="step three">
                <div className="s3-off"></div>
                  <div className="step-info">
                    <h4>STEP THREE</h4>
                    <h3>On The Way</h3>
                  </div>
              </div>
              <div className="step four">
                <div className="s4-off"></div>
                  <div className="step-info">
                    <h4>STEP FOUR</h4>
                    <h3>Delivered</h3>
                  </div>
              </div>
          </div>
          <span className="arrival-time">We can't track this order</span>
        </Aux>
        break
      default:
        break

    }

  return layout
}

export default DeliveryTrackingItem



// WEBPACK FOOTER //
// ./src/containers/DeliveryTracking/DeliveryTrackingItem/index.js